/* Onmi – wspólny skrypt sekcji: animacje pojawiania się + ulubione */

if (!customElements.get('onmi-reveal')) {
  customElements.define('onmi-reveal', class extends HTMLElement {
    connectedCallback() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.classList.add('is-ready');
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.classList.add('is-visible');
          this.observer.disconnect();
        }
      }, { threshold: 0.12 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}

/* ---------- Ulubione (zapisywane w przeglądarce klientki) ---------- */

if (!window.onmiWishlist) {
  const KEY = 'onmi-wishlist';

  window.onmiWishlist = {
    read() {
      try {
        const list = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    },

    write(list) {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (error) {
        /* tryb prywatny – lista działa do odświeżenia strony */
      }
      document.dispatchEvent(new CustomEvent('onmi:wishlist-change', { detail: { list } }));
    },

    has(handle) {
      return this.read().includes(handle);
    },

    toggle(handle) {
      const list = this.read();
      const index = list.indexOf(handle);
      if (index === -1) list.unshift(handle);
      else list.splice(index, 1);
      this.write(list);
      return index === -1;
    },

    remove(handle) {
      this.write(this.read().filter((item) => item !== handle));
    },
  };
}

if (!customElements.get('onmi-wishlist-button')) {
  customElements.define('onmi-wishlist-button', class extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.button = this.querySelector('button');
      if (!this.handle || !this.button) return;

      this.onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.onmiWishlist.toggle(this.handle);
      };
      this.onChange = () => this.render();

      this.button.addEventListener('click', this.onClick);
      document.addEventListener('onmi:wishlist-change', this.onChange);
      window.addEventListener('storage', this.onChange);
      this.render();
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('onmi:wishlist-change', this.onChange);
      window.removeEventListener('storage', this.onChange);
    }

    render() {
      const active = window.onmiWishlist.has(this.handle);
      this.button.setAttribute('aria-pressed', String(active));
      const label = this.querySelector('[data-label]');
      if (label) label.textContent = active ? this.dataset.labelActive : this.dataset.labelIdle;
      if (this.dataset.ariaIdle) {
        this.button.setAttribute('aria-label', active ? this.dataset.ariaActive : this.dataset.ariaIdle);
      }
    }
  });
}

if (!customElements.get('onmi-wishlist-page')) {
  customElements.define('onmi-wishlist-page', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.onChange = () => this.render();
      document.addEventListener('onmi:wishlist-change', this.onChange);
      window.addEventListener('storage', this.onChange);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('onmi:wishlist-change', this.onChange);
      window.removeEventListener('storage', this.onChange);
    }

    money(cents) {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
      const locale = document.documentElement.lang || 'pl';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    imageUrl(src, width) {
      if (!src) return '';
      const url = src.startsWith('//') ? 'https:' + src : src;
      return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
    }

    async fetchProduct(handle) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
      if (!response.ok) return null;
      return response.json();
    }

    card(product, index) {
      const card = document.createElement('div');
      card.className = 'onmi-pcard';
      card.style.setProperty('--i', index);

      const media = document.createElement('div');
      media.className = 'onmi-pcard__media';

      const mediaLink = document.createElement('a');
      mediaLink.className = 'onmi-pcard__media-link';
      mediaLink.href = product.url;
      mediaLink.setAttribute('aria-label', product.title);

      if (product.featured_image) {
        const img = document.createElement('img');
        img.className = 'onmi-pcard__img';
        img.loading = 'lazy';
        img.alt = product.title;
        img.src = this.imageUrl(product.featured_image, 800);
        img.srcset = [400, 600, 800, 1000].map((w) => this.imageUrl(product.featured_image, w) + ' ' + w + 'w').join(', ');
        img.sizes = '(min-width: 990px) 25vw, 50vw';
        mediaLink.appendChild(img);
      }
      media.appendChild(mediaLink);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'onmi-heart';
      remove.setAttribute('aria-pressed', 'true');
      remove.setAttribute('aria-label', this.dataset.removeLabel || 'Usuń z ulubionych');
      remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.5 2.8c0 5.7-7.5 10.3-7.5 10.3z"/></svg>';
      remove.addEventListener('click', () => window.onmiWishlist.remove(product.handle));
      media.appendChild(remove);

      if (!product.available) {
        const badge = document.createElement('span');
        badge.className = 'onmi-badge onmi-badge--muted';
        badge.textContent = this.dataset.soldOut || 'Wyprzedane';
        media.appendChild(badge);
      }

      const info = document.createElement('div');
      info.className = 'onmi-pcard__info';
      const title = document.createElement('a');
      title.className = 'onmi-pcard__title';
      title.href = product.url;
      title.textContent = product.title;
      const price = document.createElement('p');
      price.className = 'onmi-pcard__price';
      price.textContent = (product.price_varies ? 'od ' : '') + this.money(product.price);
      if (product.compare_at_price > product.price) {
        const old = document.createElement('s');
        old.textContent = this.money(product.compare_at_price);
        price.appendChild(old);
      }
      info.append(title, price);

      if (product.available) {
        const atc = document.createElement('button');
        atc.type = 'button';
        atc.className = 'onmi-btn onmi-atc';
        const multi = (product.variants || []).filter((variant) => variant.available).length > 1;
        atc.textContent = multi ? 'Wybierz rozmiar' : 'Dodaj do koszyka';
        atc.addEventListener('click', async () => {
          if (multi) { window.location.href = product.url; return; }
          const variant = (product.variants || []).find((item) => item.available);
          if (!variant) { window.location.href = product.url; return; }
          atc.disabled = true;
          const previous = atc.textContent;
          atc.textContent = 'Dodaj\u0119...';
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
            });
            if (!response.ok) throw new Error('add failed');
            atc.textContent = 'W koszyku \u2713';
            document.dispatchEvent(new CustomEvent('onmi:cart-change'));
            if (typeof window.onmiRefreshCart === 'function') window.onmiRefreshCart();
            setTimeout(() => { atc.textContent = previous; atc.disabled = false; }, 1800);
          } catch (error) {
            window.location.href = product.url;
          }
        });
        info.appendChild(atc);
      }

      card.append(media, info);
      return card;
    }

    async render() {
      const token = (this.renderToken = Symbol('render'));
      const handles = window.onmiWishlist.read();

      if (!handles.length) {
        this.grid.replaceChildren();
        this.grid.hidden = true;
        this.empty.hidden = false;
        return;
      }

      const products = await Promise.all(handles.map((handle) => this.fetchProduct(handle).catch(() => null)));
      if (token !== this.renderToken) return;

      const existing = products.filter(Boolean);
      if (existing.length !== handles.length) {
        window.onmiWishlist.write(existing.map((product) => product.handle));
        return;
      }

      this.grid.replaceChildren(...existing.map((product, index) => this.card(product, index)));
      this.grid.hidden = false;
      this.empty.hidden = true;
    }
  });
}

/* ---------- Karuzela (przeciąganie, strzałki, pasek postępu) ---------- */

if (!customElements.get('onmi-carousel')) {
  customElements.define('onmi-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.thumb = this.querySelector('[data-thumb]');

      this.update = this.update.bind(this);
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);

      this.bindDrag();
      if (this.hasAttribute('loop')) this.setupLoop();
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    step() {
      const item = this.track.firstElementChild;
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(direction) {
      this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
    }

    setupLoop() {
      const track = this.track;
      const originals = [...track.children];
      if (originals.length < 2) return;

      const makeClones = () => originals.map((node) => {
        const copy = node.cloneNode(true);
        copy.dataset.clone = 'true';
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        return copy;
      });

      track.prepend(...makeClones());
      track.append(...makeClones());
      this.loop = true;
      track.dataset.loopReady = 'true';

      const place = () => {
        this.setWidth = track.scrollWidth / 3;
        if (this.setWidth > 0) track.scrollLeft = this.setWidth;
      };
      requestAnimationFrame(place);
      window.addEventListener('resize', () => requestAnimationFrame(place), { passive: true });

      track.addEventListener('scroll', () => {
        if (!this.setWidth) return;
        if (track.scrollLeft < this.setWidth * 0.5) track.scrollLeft += this.setWidth;
        else if (track.scrollLeft > this.setWidth * 1.5) track.scrollLeft -= this.setWidth;
      }, { passive: true });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const max = scrollWidth - clientWidth;
      const scrollable = max > 2;
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prevButton) this.prevButton.disabled = this.loop ? false : (!scrollable || scrollLeft <= 2);
      if (this.nextButton) this.nextButton.disabled = this.loop ? false : (!scrollable || scrollLeft >= max - 2);
      if (this.thumb) {
        this.thumb.style.width = (scrollable ? (clientWidth / scrollWidth) * 100 : 100) + '%';
        this.thumb.style.transform = 'translateX(' + (scrollable ? (scrollLeft / clientWidth) * 100 : 0) + '%)';
      }
    }

    bindDrag() {
      let active = false;
      let moved = false;
      let startX = 0;
      let lastX = 0;
      let startLeft = 0;

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        active = true;
        moved = false;
        startX = event.clientX;
        lastX = event.clientX;
        startLeft = this.track.scrollLeft;
      });

      this.track.addEventListener('pointermove', (event) => {
        if (!active) return;
        const distance = event.clientX - startX;
        if (!moved && Math.abs(distance) > 6) {
          moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        if (moved) this.track.scrollLeft -= event.clientX - lastX;
        lastX = event.clientX;
      });

      const end = () => {
        if (!active) return;
        active = false;
        if (!moved) return;
        const step = this.step();
        const target = Math.round(this.track.scrollLeft / step) * step;
        this.track.classList.remove('is-dragging');
        this.track.scrollTo({ left: target, behavior: 'smooth' });
      };

      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);
      this.track.addEventListener('lostpointercapture', end);

      this.track.addEventListener('click', (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, true);

      this.track.addEventListener('dragstart', (event) => event.preventDefault());
    }
  });
}

/* ---------- Kalkulator rozmiaru (tabela rozmiarów dla wielu marek) ---------- */

if (!customElements.get('onmi-size-finder')) {
  const MEASURES = [
    { key: 'bust', label: 'Biust' },
    { key: 'waist', label: 'Talia' },
    { key: 'hips', label: 'Biodra' },
  ];
  const STORAGE_KEY = 'onmi-measurements';
  const ALL = '__all';

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  customElements.define('onmi-size-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.select = this.form.elements.brand;
      this.error = this.querySelector('[data-error]');
      this.result = this.querySelector('[data-result]');
      this.table = this.querySelector('[data-table]');

      let raw = [];
      try {
        raw = JSON.parse(this.querySelector('[data-charts]').textContent);
      } catch (error) {
        raw = [];
      }
      this.brands = raw
        .map((brand) => ({ name: (brand.name || '').trim(), note: (brand.note || '').trim(), rows: this.parse(brand.chart) }))
        .filter((brand) => brand.name && brand.rows.length);

      if (!this.brands.length) {
        this.hidden = true;
        return;
      }

      this.fillSelect();
      this.restore();

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.calculate(true);
      });
      this.select.addEventListener('change', () => this.calculate(false));
      this.calculate(false);
    }

    parseRange(cell) {
      const numbers = (cell.match(/\d+(?:[.,]\d+)?/g) || []).map((n) => parseFloat(n.replace(',', '.')));
      if (!numbers.length) return null;
      return [Math.min(...numbers), Math.max(...numbers)];
    }

    parse(text) {
      return String(text || '')
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
          const cells = line.split(/[|;\t]/).map((cell) => cell.trim());
          if (cells.length < 2 || !cells[0] || /^rozmiar/i.test(cells[0])) return null;
          const row = { size: cells[0] };
          MEASURES.forEach((measure, index) => {
            row[measure.key] = this.parseRange(cells[index + 1] || '');
          });
          return MEASURES.some((measure) => row[measure.key]) ? row : null;
        })
        .filter(Boolean);
    }

    fillSelect() {
      const wanted = (new URLSearchParams(window.location.search).get('marka') || '').trim().toLowerCase();
      this.select.replaceChildren();
      this.brands.forEach((brand, index) => {
        const option = el('option', '', brand.name);
        option.value = String(index);
        if (wanted && brand.name.toLowerCase() === wanted) option.selected = true;
        this.select.appendChild(option);
      });
      if (this.brands.length > 1) {
        const all = el('option', '', 'Wszystkie marki');
        all.value = ALL;
        this.select.appendChild(all);
      }
    }

    values() {
      const values = {};
      MEASURES.forEach(({ key }) => {
        const number = parseFloat(String(this.form.elements[key].value).replace(',', '.'));
        if (number >= 40 && number <= 250) values[key] = number;
      });
      return values;
    }

    restore() {
      try {
        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
        MEASURES.forEach(({ key }) => {
          if (saved[key] && !this.form.elements[key].value) this.form.elements[key].value = saved[key];
        });
      } catch (error) {
        /* brak zapisanych wymiarów */
      }
    }

    save(values) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(values));
      } catch (error) {
        /* tryb prywatny */
      }
    }

    recommend(brand, values) {
      const per = {};
      let index = -1;
      let smallest = Infinity;
      let tooBig = false;
      let edge = false;

      MEASURES.forEach(({ key }) => {
        const value = values[key];
        if (!value) return;
        const rows = brand.rows;
        let match = rows.findIndex((row) => row[key] && value <= row[key][1]);
        let over = false;
        if (match === -1) {
          const withMeasure = rows.map((row, i) => (row[key] ? i : -1)).filter((i) => i >= 0);
          if (!withMeasure.length) return;
          match = withMeasure[withMeasure.length - 1];
          over = true;
          tooBig = true;
        }
        per[key] = { size: rows[match].size, over };
        if (!over && rows[match][key][1] - value <= 0.5 && match < rows.length - 1) per[key].edge = true;
        index = Math.max(index, match);
        smallest = Math.min(smallest, match);
      });

      if (index === -1) return null;
      MEASURES.forEach(({ key }) => {
        if (per[key] && per[key].edge && per[key].size === brand.rows[index].size) edge = true;
      });

      return {
        index,
        size: brand.rows[index].size,
        per,
        tooBig,
        smaller: smallest < index ? brand.rows[index - 1].size : null,
        next: edge && brand.rows[index + 1] ? brand.rows[index + 1].size : null,
      };
    }

    explain(brand, rec) {
      if (rec.tooBig) return 'Twoje wymiary są większe niż największy rozmiar w tabeli tej marki. Sprawdź inne marki albo napisz do nas, pomożemy.';
      if (rec.smaller) return 'Twoje wymiary wypadają w różnych rozmiarach, więc polecamy większy, żeby nic nie uciskało. Przy luźnych fasonach może pasować też ' + rec.smaller + '.';
      if (rec.next) return 'Jesteś na granicy rozmiaru. Przy dopasowanych fasonach wybierz ' + rec.next + '.';
      return 'Twoje wymiary mieszczą się w tym rozmiarze.';
    }

    calculate(fromSubmit) {
      const values = this.values();
      const hasAny = Object.keys(values).length > 0;
      const choice = this.select.value;
      const brand = choice === ALL ? null : this.brands[Number(choice)];

      this.error.hidden = true;
      if (!hasAny) {
        this.result.replaceChildren();
        this.renderTable(brand, null);
        if (fromSubmit) {
          this.error.textContent = 'Wpisz przynajmniej jeden wymiar w centymetrach, np. biust 88.';
          this.error.hidden = false;
        }
        return;
      }

      this.save(values);
      if (brand) this.renderOne(brand, values);
      else this.renderAll(values);
      if (fromSubmit) this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    chips(rec, values) {
      const chips = el('div', 'onmi-finder__chips');
      MEASURES.forEach(({ key, label }) => {
        if (!values[key] || !rec.per[key]) return;
        chips.appendChild(el('span', 'onmi-finder__chip', label + ' ' + values[key] + ' cm → ' + rec.per[key].size + (rec.per[key].over ? '+' : '')));
      });
      return chips;
    }

    renderOne(brand, values) {
      const rec = this.recommend(brand, values);
      if (!rec) {
        this.result.replaceChildren(el('div', 'onmi-finder__result onmi-finder__result--plain', 'Tabela marki ' + brand.name + ' nie ma wymiarów, które wpisałaś. Wpisz inny wymiar.'));
        this.renderTable(brand, null);
        return;
      }

      const box = el('div', 'onmi-finder__result');
      box.appendChild(el('div', 'onmi-finder__size', rec.tooBig ? rec.size + '+' : rec.size));
      const details = el('div', 'onmi-finder__details');
      details.appendChild(el('p', 'onmi-finder__headline', rec.tooBig ? 'W marce ' + brand.name + ' największy rozmiar to ' + rec.size : 'W marce ' + brand.name + ' wybierz rozmiar ' + rec.size));
      details.appendChild(el('p', 'onmi-finder__text', this.explain(brand, rec)));
      details.appendChild(this.chips(rec, values));
      if (brand.note) details.appendChild(el('p', 'onmi-finder__note', brand.note));
      box.appendChild(details);

      this.result.replaceChildren(box);
      this.renderTable(brand, rec.index);
    }

    renderAll(values) {
      const box = el('div', 'onmi-finder__result onmi-finder__result--all');
      box.appendChild(el('p', 'onmi-finder__headline', 'Twój rozmiar w poszczególnych markach'));
      const list = el('div', 'onmi-finder__brands');
      this.brands.forEach((brand, index) => {
        const rec = this.recommend(brand, values);
        const item = el('button', 'onmi-finder__brand');
        item.type = 'button';
        item.appendChild(el('span', 'onmi-finder__brand-name', brand.name));
        item.appendChild(el('span', 'onmi-finder__brand-size', rec ? (rec.tooBig ? rec.size + '+' : rec.size) : '–'));
        item.addEventListener('click', () => {
          this.select.value = String(index);
          this.calculate(false);
        });
        list.appendChild(item);
      });
      box.appendChild(list);
      box.appendChild(el('p', 'onmi-finder__text', 'Kliknij markę, żeby zobaczyć szczegóły i jej tabelę rozmiarów.'));
      this.result.replaceChildren(box);
      this.renderTable(null, null);
    }

    renderTable(brand, matchIndex) {
      if (!brand) {
        this.table.hidden = true;
        this.table.replaceChildren();
        return;
      }
      const columns = MEASURES.filter(({ key }) => brand.rows.some((row) => row[key]));
      const table = el('table');
      const caption = el('caption', 'onmi-finder__caption', 'Tabela rozmiarów: ' + brand.name + ' (wymiary ciała w cm)');
      table.appendChild(caption);
      const head = el('thead');
      const headRow = el('tr');
      headRow.appendChild(el('th', '', 'Rozmiar'));
      columns.forEach(({ label }) => headRow.appendChild(el('th', '', label)));
      head.appendChild(headRow);
      const body = el('tbody');
      brand.rows.forEach((row, index) => {
        const tr = el('tr', index === matchIndex ? 'is-match' : '');
        tr.appendChild(el('td', '', row.size));
        columns.forEach(({ key }) => {
          const range = row[key];
          tr.appendChild(el('td', '', range ? (range[0] === range[1] ? String(range[0]) : range[0] + '–' + range[1]) : '–'));
        });
        body.appendChild(tr);
      });
      table.append(head, body);
      this.table.replaceChildren(table);
      this.table.hidden = false;
    }
  });
}


/* Karta prezentowa: ukryj sekcje, ktore jej nie dotycza */
(function(){
  if (!document.body || !document.body.classList.contains('onmi-gc-product')) return;
  var hide = /materia|wysy/i;
  document.querySelectorAll('details summary').forEach(function (s) {
    if (hide.test(s.textContent.trim())) {
      var d = s.closest('details');
      if (d) d.style.display = 'none';
    }
  });
})();


/* ---------- Karty produktu: sama ikona koszyka + serduszko ulubionych ---------- */
(function () {
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.6 8h10.8l.9 11.3a1.6 1.6 0 0 1-1.6 1.7H7.3a1.6 1.6 0 0 1-1.6-1.7z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9.2 9.4V6.6a2.8 2.8 0 0 1 5.6 0v2.8" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.4 4.8 13.2a4.5 4.5 0 0 1 6.4-6.3l.8.8.8-.8a4.5 4.5 0 0 1 6.4 6.3z"/></svg>';

  function cardOf(node) {
    return node.closest('.card-gallery') || node.closest('.product-card') || node.closest('li') || node.parentElement;
  }

  function productLink(card) {
    if (!card) return null;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) {
      var wrap = card.parentElement;
      a = wrap ? wrap.querySelector('a[href*="/products/"]') : null;
    }
    return a ? a.getAttribute('href') : null;
  }

  function handleOf(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function paint(btn, on) {
    btn.classList.toggle('is-active', !!on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Usun z ulubionych' : 'Dodaj do ulubionych');
    btn.setAttribute('title', on ? 'Usun z ulubionych' : 'Dodaj do ulubionych');
  }

  function decorate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('quick-add-component');
    for (var i = 0; i < list.length; i++) {
      var qa = list[i];
      if (qa.dataset.onmiCard) continue;
      qa.dataset.onmiCard = '1';

      var card = cardOf(qa);
      var href = productLink(card);
      var handle = handleOf(href);

      var choose = qa.querySelector('.quick-add__button--choose');
      if (choose && href) {
        var link = document.createElement('a');
        link.href = href;
        link.className = 'onmi-card-btn onmi-card-btn--bag';
        link.setAttribute('aria-label', 'Zobacz produkt i wybierz rozmiar');
        link.setAttribute('title', 'Zobacz produkt i wybierz rozmiar');
        link.innerHTML = BAG;
        choose.parentNode.replaceChild(link, choose);
      }

      var addBtn = qa.querySelector('.quick-add__button--add');
      if (addBtn) {
        addBtn.classList.add('onmi-card-btn', 'onmi-card-btn--bag');
        addBtn.setAttribute('title', 'Dodaj do koszyka');
      }

      if (!handle || qa.querySelector('.onmi-card-fav')) continue;

      var fav = document.createElement('button');
      fav.type = 'button';
      fav.className = 'onmi-card-btn onmi-card-fav';
      fav.innerHTML = HEART;
      fav.setAttribute('data-handle', handle);
      paint(fav, !!(window.onmiWishlist && window.onmiWishlist.has(handle)));
      (function (button, key) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!window.onmiWishlist) return;
          window.onmiWishlist.toggle(key);
          paint(button, window.onmiWishlist.has(key));
        });
      })(fav, handle);
      qa.appendChild(fav);
    }
  }

  function placeHearts() {
    var comps = document.querySelectorAll('quick-add-component');
    for (var i = 0; i < comps.length; i++) {
      var fav = comps[i].querySelector('.onmi-card-fav');
      if (!fav) continue;
      var bag = comps[i].querySelector('.onmi-card-btn--bag');
      var hidden = !bag || getComputedStyle(bag).display === 'none';
      fav.classList.toggle('onmi-card-fav--corner', hidden);
    }
  }

  function refreshAll() {
    var hearts = document.querySelectorAll('.onmi-card-fav');
    for (var i = 0; i < hearts.length; i++) {
      var key = hearts[i].getAttribute('data-handle');
      paint(hearts[i], !!(window.onmiWishlist && window.onmiWishlist.has(key)));
    }
  }

  function boot() { decorate(document); placeHearts(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) { decorate(event.target); });
  document.addEventListener('onmi:wishlist-change', refreshAll);
  window.addEventListener('storage', refreshAll);
  window.addEventListener('resize', function () { placeHearts(); });

  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; decorate(document); placeHearts(); }, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
